;(function($){

    function Proposals() {
        var _ = this;
        _.API = $("#app_url").val() + "/api/";

        $.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'Authorization': "Bearer "+$('meta[name="app-token"]').attr('content'),
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });

        $("#proposals_type").on("change", function(e){
            $("select#customers_id").attr('disabled', false).html("");

            if($(this).val() != "") {
                _.getCustomers($(this).val());
            }             
        });

        $("#customers_id").on("change", function(e){
            e.preventDefault();
            if($(this).val() != ""){ 
                _.getContractsActive($(this).val());
            }
        });



        if($("#proposals_type").val() != ""  &&  $("#proposals_type").val() !== undefined) {
            _.getCustomers($("#proposals_type").val());
        }        
    }

    Proposals.prototype.getCustomers = function(type) {
        var _ =  this;
        
        $.get(_.API + "clientes/prospecto/"+type, function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
                var selectedStatus = ($("select#customers_id").data('active') == index) ? "selected" : "";
               html += '<option value="'+ index +'" '+ selectedStatus +'>'+ value +'</option>';
            });

            $("select#customers_id").attr('disabled', false).html(html);
            $("select#customers_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });
        });
    }; 

     Proposals.prototype.getContractsActive = function(type) {
        var _ =  this;
        
        $.get(_.API + "contratos-ativos/"+type, function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
                var selectedStatus = ($("select#contracts_id").data('active') == index) ? "selected" : "";
               html += '<option value="'+ index +'" '+ selectedStatus +'>'+ value +'</option>';
            });

            $("select#contracts_id").attr('disabled', false).html(html);
            $("select#contracts_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });
        });
    }; 

   new Proposals();

}(jQuery));